import { useEffect, useState } from 'react';
import { Button, Col, Row } from 'react-bootstrap';

const SendInfoHubNotiModal = ({ handleClose, show, files, onPushNoti }) => {
    const showHideClassName = show
        ? 'delete-modal display-block'
        : 'delete-modal display-none';
        
    const [notification, setNotification] = useState('');

    useEffect(() => {
        if (Object.keys(files).length !== 0) {
            if (files.fileEmployee.indexOf(',') > -1) {
                let array = files.fileEmployee.split(',')

                for (let i = 0; i < array.length; i++) {
                    let mappedArray = array.map((item) => ({
                        id: files.fileID,
                        title: files.fileName,
                        employee: item.toLowerCase().replaceAll(' ', ''),
                    }));

                    setNotification(mappedArray)
                }
            } else {
                let mappedString = [{ id: files.fileID, title: files.fileName, employee: files.fileEmployee}]

                setNotification(mappedString)
            }
        }

    }, [files]);

    const sendNotification = () =>  {
        onPushNoti({
            notification
        });
    }

    return (
        <div className={showHideClassName}>
            <section className='delete-modal-main'>
                <Row>
                    <Col>
                        <h4 className='noti-modal-title'>Send Notification?</h4>
                        <p>Send notification for this file?</p>
                        <Button variant='primary' onClick={sendNotification}>Send Notification</Button>
                        <Button variant='outline-primary' onClick={handleClose} style={{borderColor:'white'}}>
                            Cancel
                        </Button>
                    </Col>
                </Row>
            </section>
        </div>
    );
};

export default SendInfoHubNotiModal;
